import React from 'react';
import logo from '../images/logo.png';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import HeaderMenu from './HeaderMenu';
import MobileHeaderMenu from './MobileHeaderMenu';
import Options from './Options';
import { useBreakpoint, withBreakpoints } from 'gatsby-plugin-breakpoints';
import SearchBar from './SearchBar';
import headerStyle from '../styles/header.scss'
import MobileArrow from '../images/MobileHeaderMenu.png';
import Twitter from '../images/TwitterLogo.png';
import LinkedinLogo from '../images/LinkedinLogo.png';
import FacebookLogo from '../images/FacebookLogo.png'

const Header = ({ siteTitle, onClick, data = {}, style }) => {
  const breakpoints = useBreakpoint();
  const handleClick = () => onClick('onClick_event', 'logo clicked');
  const mobileHeaderMenuStyle = `
    .arrow-btn {
      &:after {
          background-image: url(${MobileArrow}) !important;
      }
    }
    button.arrow-btn {
      min-width: 25px;
      max-width: 25px;
      height: 25px;
      background-image: url(${MobileArrow}) !important;
      background-repeat: no-repeat;
      border: none;
      background-color: transparent;
    }
  `

  const headerOptionsStyle = `
    .share {
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='19' viewBox='0 0 24 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.2 7.2L16.2 12.8V8.614C12.588 8.698 9.368 9.244 6.4 12.8C6.806 7.802 10.124 4.876 16.2 4.484V0.2L23.2 7.2ZM3.6 15.6H19V12.8L21.8 10.56V18.4H0.800003V3H14.002C11.44 3.448 9.368 4.4 7.828 5.8H3.6V15.6Z' fill='%231D68AA'/%3E%3C/svg%3E%0A");    }
    .print {
      background-image: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.0469 5.5043V0.6875H3.95312V5.5043C3.07266 5.54942 2.24309 5.9307 1.63547 6.56949C1.02786 7.20828 0.688546 8.05588 0.6875 8.9375V17.1875H3.60938V15.8125H2.0625V8.9375C2.06311 8.39068 2.28061 7.86643 2.66727 7.47977C3.05393 7.09311 3.57818 6.87561 4.125 6.875H17.875C18.4218 6.87561 18.9461 7.09311 19.3327 7.47977C19.7194 7.86643 19.9369 8.39068 19.9375 8.9375V15.8125H18.0469V17.1875H21.3125V8.9375C21.3115 8.05588 20.9721 7.20828 20.3645 6.56949C19.7569 5.9307 18.9273 5.54942 18.0469 5.5043ZM16.6719 5.5H5.32812V2.0625H16.6719V5.5Z' fill='%231D68AA'/%3E%3Cpath d='M17.0156 8.59375H18.3906V9.96875H17.0156V8.59375Z' fill='%231D68AA'/%3E%3Cpath d='M4.98438 11.3438H3.26562V12.7188H4.98438V21.3125H16.6719V12.7188H18.3906V11.3438H4.98438ZM15.2969 19.9375H6.35938V12.7188H15.2969V19.9375Z' fill='%231D68AA'/%3E%3C/svg%3E%0A");    }
    .twitter {
      background: url(${Twitter});
    }
    .linkedin {
      background: url(${LinkedinLogo});
    }
    .facebook {
      background: url(${FacebookLogo});
    }
    .social-media {
      background-image: url("data:image/svg+xml,%3Csvg width='26' height='21' viewBox='0 0 26 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 20.2H25V17.8C24.9999 17.0518 24.7668 16.3223 24.333 15.7127C23.8991 15.1032 23.2862 14.644 22.5793 14.3989C21.8724 14.1538 21.1067 14.1351 20.3887 14.3452C19.6707 14.5554 19.036 14.984 18.5728 15.5716M19 20.2H7M19 20.2V17.8M19 20.2C19 20.2 19 18.76 19 17.8M18.5728 15.5716C18.8488 16.2604 19 17.0128 19 17.8M18.5728 15.5716C18.1272 14.4579 17.3581 13.5034 16.3648 12.8309C15.3715 12.1585 14.1995 11.7992 13 11.7992C11.8005 11.7992 10.6285 12.1585 9.6352 12.8309C8.64189 13.5034 7.87283 14.4579 7.4272 15.5716M18.5728 15.5716C18.5728 15.5716 19 16.84 19 17.8M7 20.2H1V17.8C1.00005 17.0518 1.2332 16.3223 1.66703 15.7127C2.10086 15.1032 2.71382 14.644 3.4207 14.3989C4.12758 14.1538 4.89325 14.1351 5.61129 14.3452C6.32932 14.5554 6.96403 14.984 7.4272 15.5716M7 20.2V17.8M7 20.2C7 20.2 7.01244 18.9041 7 17.8M7.4272 15.5716C7.1512 16.2604 7 17.0128 7 17.8M7.4272 15.5716C7.4272 15.5716 6.99029 16.9378 7 17.8M16.6 4.6C16.6 5.55478 16.2207 6.47045 15.5456 7.14558C14.8705 7.82072 13.9548 8.2 13 8.2C12.0452 8.2 11.1295 7.82072 10.4544 7.14558C9.77928 6.47045 9.4 5.55478 9.4 4.6C9.4 3.64522 9.77928 2.72955 10.4544 2.05442C11.1295 1.37928 12.0452 1 13 1C13.9548 1 14.8705 1.37928 15.5456 2.05442C16.2207 2.72955 16.6 3.64522 16.6 4.6ZM23.8 8.2C23.8 8.83652 23.5471 9.44697 23.0971 9.89705C22.647 10.3471 22.0365 10.6 21.4 10.6C20.7635 10.6 20.153 10.3471 19.7029 9.89705C19.2529 9.44697 19 8.83652 19 8.2C19 7.56348 19.2529 6.95303 19.7029 6.50294C20.153 6.05286 20.7635 5.8 21.4 5.8C22.0365 5.8 22.647 6.05286 23.0971 6.50294C23.5471 6.95303 23.8 7.56348 23.8 8.2ZM7 8.2C7 8.83652 6.74714 9.44697 6.29706 9.89705C5.84697 10.3471 5.23652 10.6 4.6 10.6C3.96348 10.6 3.35303 10.3471 2.90294 9.89705C2.45286 9.44697 2.2 8.83652 2.2 8.2C2.2 7.56348 2.45286 6.95303 2.90294 6.50294C3.35303 6.05286 3.96348 5.8 4.6 5.8C5.23652 5.8 5.84697 6.05286 6.29706 6.50294C6.74714 6.95303 7 7.56348 7 8.2Z' stroke='%231D68AA' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    }
  `
  return (
    <>
      <header css={[css(headerStyle), css(headerOptionsStyle), css(style)]} className="header">
        <div className="header-container">
          <a href='/' className='logo'
            onClick={handleClick}
            onKeyDown={handleClick}
          >
            <img src={logo} alt={'Burlington'} />
          </a>
          <div className='right-container'>
            <div className='options'>
              {!breakpoints.md && <Options platform={siteTitle} style={headerOptionsStyle} />}
            </div>
            <SearchBar />
          </div>
          {breakpoints.md && data && <MobileHeaderMenu data={data} style={mobileHeaderMenuStyle} />}
        </div>
      </header>
      {!breakpoints.md && data && <HeaderMenu data={data} />}
    </>
  )
}
const HeaderStyled = (props) => (
  <Header {...props} style={props.style} />
);

Header.propTypes = {
  data: PropTypes.shape({}),
  style: PropTypes.string,
  onClick: PropTypes.func,
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  data: {},
  style: '',
  onClick: () => { },
  siteTitle: ''
};

HeaderStyled.propTypes = {
  data: PropTypes.shape({}),
  style: PropTypes.string,
  onClick: PropTypes.func,
  siteTitle: PropTypes.string
};

HeaderStyled.defaultProps = {
  data: {},
  style: '',
  onClick: () => { },
  siteTitle: ''
};

export default withBreakpoints(HeaderStyled);
